import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable()
export class SwitchUserInterceptor implements HttpInterceptor {
    private session = inject(SessionService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.shouldIntercept(req.url) && this.session.isUserSwitched() && false === req.params.has('_switch_user')) {
            req = req.clone({params: req.params.append('_switch_user', this.session.switchedUser().username)});
        }

        return next.handle(req);
    }

    private shouldIntercept(url: string): boolean {
        return url.includes('/portal/');
    }
}
